import * as API from "./Api";

export const getJobs = (status, page, limit) =>
  API.get(`job/${status}?page=${page}&limit=${limit}`);
export const getJobById = (id) => API.get(`job/details/${id}`);
export const createJob = (data) => API.post("job", data);
export const updateJob = (id, data) => API.patch(`job/${id}`, data);
export const deleteJob = (id) => API.remove(`job/${id}`);
export const jobAction = (id, data) => API.put(`job/action/${id}`, data);
export const completeJob = (id, data) => API.put(`job/complete/${id}`, data);
export const actionUploadedWork = (id, data) =>
  API.put(`job/action-uploaded-work/${id}`, data);
export const createTicket = (data) => API.post(`job/create-ticket`, data);
